import Endpoint from 'modules/reports/orm/Endpoint'
import Model from 'modules/reports/orm/Model'

export default class DeleteEndpoint<RequestT, T extends Model, MetaT = {}> extends Endpoint<
  RequestT,
  T,
  MetaT
> {
  method = 'delete'
}
